import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';


import useDownloadOrderContents from '../hooks/useDownloadOrderContents';
import {ConfirmationButton} from '../../../global/Button';
import {I18nMessage} from '../../I18n';

import styles from './OrderDownloadContents.scss';


function OrderDownloadContents({orderId}) {

    const [isDownloadActive, setIsDownloadActive] = useState(false);
    const downloadOrderContents = useDownloadOrderContents();

    const onDownloadStop = () => setIsDownloadActive(false);

    const downloadOrder = async () => {

        setIsDownloadActive(true);

        // on both complete and error, update the state
        downloadOrderContents(orderId, onDownloadStop, onDownloadStop);
    };

    return (
        <div className={styles.orderDownloadContents}>
            <h3>
                <I18nMessage id={'order.download.contents.headline'}/>
            </h3>
            <p>
                <I18nMessage id={'order.download.contents.infoTextGeneral'}/><br/>
                <I18nMessage id={'order.download.contents.infoTextFormat'}/>
            </p>
            <ConfirmationButton
                isDisabled={isDownloadActive}
                labelI18n={'order.download.contents.button.label'}
                onClick={() => downloadOrder()}
            />
        </div>
    );
}


OrderDownloadContents.propTypes = {
    orderId: PropTypes.string.isRequired
};

OrderDownloadContents.defaultProps = {};


export default OrderDownloadContents;
